module.exports = __webpack_public_path__ + "img/iPhone-currency.de83a619.webp";